// removed by extract-text-webpack-plugin
module.exports = {"tabContainer":"styles__tabContainer___3dc2Z","tabHeader":"styles__tabHeader___3vx3c","tabSelected":"styles__tabSelected___1q9we","tabDisabled":"styles__tabDisabled___Z6cf7","tabPanel":"styles__tabPanel___sT2VJ","tabPanelSelected":"styles__tabPanelSelected___3Kdax","tabPanelWrapper":"styles__tabPanelWrapper___1lyaG"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/styles.css
// module id = 1104
// module chunks = 0